import React, { useEffect, useState } from 'react';
import { StyleSheet } from 'react-native';
import { OrderProduct } from '../interfaces';

interface OrderOptionsPopupProps {
    onClose: () => void;
    onAddNote: () => void;
    onAddAddon: () => void;
    onAddVariant: () => void;
    onAddDiscount: () => void;
    onTransferProduct: () => void;
    orderProduct: OrderProduct;
}


const OrderOptionsPopup: React.FC<OrderOptionsPopupProps> = ({ onClose, onAddNote, onAddAddon, onAddVariant, onAddDiscount, onTransferProduct, orderProduct }) => {
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);


    useEffect(() => {
        const handleResize = () => {
            console.log("onresize: innerWidth: " + window.innerWidth + "innerHeight: " + innerHeight)
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.onresize = handleResize;

        return () => {
            window.onresize = null;
        };
    }, []);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    useEffect(() => {
        const updateSize = () => {
            console.log("update size")
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener("resize", updateSize);
        window.addEventListener("focus", updateSize);
        document.addEventListener("visibilitychange", updateSize);

        return () => {
            window.removeEventListener("resize", updateSize);
            window.removeEventListener("focus", updateSize);
            document.removeEventListener("visibilitychange", updateSize);
        };
    }, []);

    const styles = StyleSheet.create({
        popup: {
            width: windowSize.width > 900 ? windowSize.width * 0.40 : windowSize.width * 0.9,
            backgroundColor: '#fff',
            position: 'absolute',
            zIndex: 1000,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
        },
    });


    return (
        <div style={styles.popup} className='ds-pop ds-pop--center'>
            <div className='d-flex px-3 pt-3 justify-content-end'>
                <button className='text-btn p-0 m-0 d-flex justify-content-center' onClick={onClose}>
                    <svg width="10" height="10" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 1L1 13M1 1L13 13" stroke="#98A2B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
            <div className='px-4 pb-3'>
                <h5>Order Options</h5>

                <div className='border-box p-2 mt-2 d-flex justify-content-between'>
                    <div className='d-flex gap-2 align-items-center'>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.5 0C0.671573 0 2.23517e-08 0.671573 2.23517e-08 1.5C2.23517e-08 2.32843 0.671573 3 1.5 3H12.8787L0.43934 15.4393C-0.146447 16.0251 -0.146447 16.9749 0.43934 17.5607C1.02513 18.1464 1.97487 18.1464 2.56066 17.5607L15 5.12132V16.5C15 17.3284 15.6716 18 16.5 18C17.3284 18 18 17.3284 18 16.5V1.5C18 0.671573 17.3284 0 16.5 0H1.5Z" fill="#475467" />
                        </svg>
                        <label className='d-flex align-items-center'>Transfer Product</label>
                    </div>
                    <button className='blue-filled-btn' onClick={onTransferProduct}>Select</button>
                </div>

                <div className='border-box p-2 mt-2 d-flex justify-content-between'>
                    <div className='d-flex gap-2 align-items-center' >
                        <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 2H5.8C4.11984 2 3.27976 2 2.63803 2.32698C2.07354 2.6146 1.6146 3.07354 1.32698 3.63803C1 4.27976 1 5.11984 1 6.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19H13.2C14.8802 19 15.7202 19 16.362 18.673C16.9265 18.3854 17.3854 17.9265 17.673 17.362C18 16.7202 18 15.8802 18 14.2V11M18.1213 1.87868C19.2929 3.05025 19.2929 4.94975 18.1213 6.12132C16.9497 7.29289 15.0503 7.29289 13.8787 6.12132C12.7071 4.94975 12.7071 3.05025 13.8787 1.87868C15.0503 0.707107 16.9497 0.707107 18.1213 1.87868Z" stroke="#475467" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <label className='d-flex align-items-center'>Add Note</label>
                    </div>
                    <button className='blue-filled-btn' onClick={onAddNote}>Select</button>
                </div>

                {
                    orderProduct.product?.variants && orderProduct.product?.variants.length > 0 &&
                    <div className='border-box p-2 mt-2 d-flex justify-content-between'>
                        <div className='d-flex gap-2 align-items-center'>
                            <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.5 4H10.9344C13.9816 4 15.5053 4 16.0836 4.54729C16.5836 5.02037 16.8051 5.71728 16.6702 6.39221C16.514 7.17302 15.2701 8.05285 12.7823 9.81253L8.71772 12.6875C6.2299 14.4471 4.98599 15.327 4.82984 16.1078C4.69486 16.7827 4.91642 17.4796 5.41636 17.9527C5.99474 18.5 7.51836 18.5 10.5656 18.5H11.5M7 4C7 5.65685 5.65685 7 4 7C2.34315 7 1 5.65685 1 4C1 2.34315 2.34315 1 4 1C5.65685 1 7 2.34315 7 4ZM21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.3431 16.3431 15 18 15C19.6569 15 21 16.3431 21 18Z" stroke="#475467" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <label className='d-flex align-items-center'>Add Variants</label>
                        </div>
                        <button className='blue-filled-btn' onClick={onAddVariant}>Select</button>
                    </div>
                }

                {
                    orderProduct.product?.addons && orderProduct.product?.addons.length > 0 &&
                    <div className='border-box p-2 mt-2 d-flex justify-content-between'>
                        <div className='d-flex gap-2 align-items-center'>
                            <svg width="18" height="18" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7 16V4C7 3.06812 7 2.60218 6.84776 2.23463C6.64477 1.74458 6.25542 1.35523 5.76537 1.15224C5.39782 1 4.93188 1 4 1C3.06812 1 2.60218 1 2.23463 1.15224C1.74458 1.35523 1.35523 1.74458 1.15224 2.23463C1 2.60218 1 3.06812 1 4V16C1 16.9319 1 17.3978 1.15224 17.7654C1.35523 18.2554 1.74458 18.6448 2.23463 18.8478C2.60218 19 3.06812 19 4 19C4.93188 19 5.39782 19 5.76537 18.8478C6.25542 18.6448 6.64477 18.2554 6.84776 17.7654C7 17.3978 7 16.9319 7 16Z" stroke="#475467" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M17 14V6C17 5.06812 17 4.60218 16.8478 4.23463C16.6448 3.74458 16.2554 3.35523 15.7654 3.15224C15.3978 3 14.9319 3 14 3C13.0681 3 12.6022 3 12.2346 3.15224C11.7446 3.35523 11.3552 3.74458 11.1522 4.23463C11 4.60218 11 5.06812 11 6V14C11 14.9319 11 15.3978 11.1522 15.7654C11.3552 16.2554 11.7446 16.6448 12.2346 16.8478C12.6022 17 13.0681 17 14 17C14.9319 17 15.3978 17 15.7654 16.8478C16.2554 16.6448 16.6448 16.2554 16.8478 15.7654C17 15.3978 17 14.9319 17 14Z" stroke="#475467" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <label className='d-flex align-items-center'>Add Addons</label>
                        </div>
                        <button className='blue-filled-btn' onClick={onAddAddon}>Select</button>
                    </div>
                }

                <div className='border-box p-2 mt-2 d-flex justify-content-between'>
                    <div className='d-flex gap-2 align-items-center'>
                        <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 8H8.01M14 14H14.01M15 7L7 15M8.5 8C8.5 8.27614 8.27614 8.5 8 8.5C7.72386 8.5 7.5 8.27614 7.5 8C7.5 7.72386 7.72386 7.5 8 7.5C8.27614 7.5 8.5 7.72386 8.5 8ZM14.5 14C14.5 14.2761 14.2761 14.5 14 14.5C13.7239 14.5 13.5 14.2761 13.5 14C13.5 13.7239 13.7239 13.5 14 13.5C14.2761 13.5 14.5 13.7239 14.5 14ZM21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z" stroke="#475467" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <label className='d-flex align-items-center'>Add Discount</label>
                    </div>
                    <button className='blue-filled-btn' onClick={onAddDiscount}>Select</button>
                </div>
            </div>
            <div className='p-2 d-flex justify-content-end' style={{ backgroundColor: '#F3F4F6' }}>
                <button className='white-filled-btn ' onClick={onClose}>Cancel</button>
            </div>
        </div>
    );
};

export default OrderOptionsPopup;

